<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import VisualSuccess from '../components/VisualSuccess.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import { usePollingStore } from '../stores/pollingStore';
import { PollKey } from '../models/Poll';
import { onMounted } from 'vue';
import ChevronRightSVG from '@shared/assets/icon/chevron-right.svg';
import router from '@/router';
import { useDeviceSpecificationStore } from '../stores/deviceSpecificationStore';
import { useProjectStore } from '../stores/projectStore';

const pollingStore = usePollingStore();
const deviceSpecificationStore = useDeviceSpecificationStore();
const projectStore = useProjectStore();

onMounted(() => {
  pollingStore.stop(PollKey.WIFI_STATUS);
});

const next = async () => {
  if (deviceSpecificationStore.isProjectFromUK) {
    await projectStore.storeAssetManagerInvites([]);
    router.push({ name: 'NPS' });
    return;
  }
  router.push({ name: 'InviteAssetManager' });
};
</script>

<template>
  <ProgressFrame pageClass="subsection-page">
    <div class="content">
      <VisualSuccess>
        <template #title>Looks good!</template>
      </VisualSuccess>
      <div class="action-container">
        <ButtonPrimary block class="cta-button" @click="next" data-tn="next-btn">
          Next
          <template #iconRight>
            <ChevronRightSVG class="chevron-right-icon" />
          </template>
        </ButtonPrimary>
      </div>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.content {
  text-align: center;
  margin-top: 3rem;
}
.action-container {
  width: 100%;
  margin-top: @margin-top-end-of-page-section;
}
</style>
